import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";
import { ReactComponent as AddCircleIcon } from "images/auth/add-circle.svg";
import { ReactComponent as UreedIcon } from "images/profile/ureed-icon.svg";
function UreedInformation({ onEditClick = () => {}, isShowEditIcon = false }) {
  const [t] = useTranslation();
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);
  const userDetails = useSelector((state) => state.userDetails || {});
  const isShowAddIcon = !userDetails?.bankDetails?.ureedEmail;
  const user = useSelector((state) => state.user || {});
  const isLoggedInByMagicLink = user?.isAdmin ?? false;

  return (
    <div
      id="ureedSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover && !isShowAddIcon
          ? !isLoggedInByMagicLink && "bg-[#F3F5F7]"
          : ""
      }`}
      onMouseEnter={() => {
        if (!isLoggedInByMagicLink) {
          setShowEditOnHover(true);
        }
      }}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className="flex justify-between items-center self-stretch">
        <div className="flex items-center w-full gap-[12px]">
          <UreedIcon />
        </div>
        {isShowEditIcon && !isShowAddIcon && !isLoggedInByMagicLink && (
          <EditIcon
            className={`cursor-pointer ${
              isEditShowEditOnHover ? "visible" : "invisible"
            }`}
            onClick={() => {
              if (!isLoggedInByMagicLink) {
                onEditClick();
              }
            }}
          />
        )}
      </div>

      {isShowAddIcon && !isLoggedInByMagicLink && (
        <div
          className="flex gap-[8px] cursor-pointer max-w-[175px]"
          onClick={() => {
            if (!isLoggedInByMagicLink) {
              onEditClick();
            }
          }}
        >
          <AddCircleIcon />
          <div className="text-primary font-bold text-[16px] not-italic">
            {t("addUreed")}
          </div>
        </div>
      )}

      {!isShowAddIcon && (
        <div className="flex flex-wrap gap-[20px]">
          <LabelComponent
            title={t("ureedLabel")}
            subTitle={`${userDetails?.bankDetails?.ureedEmail ?? "-"}`}
          />
        </div>
      )}
    </div>
  );
}

UreedInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default UreedInformation;
